	  import Feature from 'ol/Feature.js';
      import Map from 'ol/Map.js';
      import Overlay from 'ol/Overlay.js';
      import View from 'ol/View.js';
	  import {Draw, Modify, Snap} from 'ol/interaction.js';
      import Point from 'ol/geom/Point.js';
      import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
      import TileJSON from 'ol/source/TileJSON.js';
      import VectorSource from 'ol/source/Vector.js';
      import {Icon, Style} from 'ol/style.js';
	  import TileWMS from 'ol/source/TileWMS.js';
	  import {OSM, Vector as VectorSource2} from 'ol/source.js';
      import {Circle as CircleStyle, Fill, Stroke, Style2} from 'ol/style.js';
	  import WKT from 'ol/format/WKT.js';
 
		
		
      var iconFeature = new Feature({
        geometry: new Point([-12700000, 3200000]),
        name: 'Null Island',
        population: 4000,
        rainfall: 500
      });
		var iconFeature2 = new Feature({
        geometry: new Point([-12200000, 2800000]),
        name: 'Null Island',
        population: 4000,
        rainfall: 500
      });
	  
      var iconStyle = new Style({
        image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
          anchor: [0.5, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: 'data/icon.png',
		  rotation: -Math.PI / 2.0
        }))
      });
	  var iconStyle2 = new Style({
        image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
          anchor: [0.5, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: 'data/icon.png',
		  rotation: Math.PI / 1.5
        }))
      });  
	  
	  
	  var source = new VectorSource2();
      var vector = new VectorLayer({
        source: source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({
            color: '#0000ff',
			lineDash:[8,16],
            width: 4
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33'
            })
          })
        })
      });
	  
      iconFeature.setStyle(iconStyle);
	  iconFeature2.setStyle(iconStyle2);

      var vectorSource = new VectorSource({
        features: [iconFeature,iconFeature2]
      });

      var vectorLayer = new VectorLayer({
        source: vectorSource
      });

      var rasterLayer =new TileLayer({
          extent:  [-12884991, 1870341, -11884991, 3870341],
          source: new TileWMS({
                        url: "http://gaiamapas1.inegi.org.mx/mdmCache/service/wms?",
                        params: {
                            LAYERS: "MapaBaseTopograficov61_sinsombreado",
							SRS:"EPSG:900913",
							FORMAT:"image/jpeg",
                            TILED: !0
                        },
                        serverType: "geoserver",
                        transition: 0
                    })
        });
	
	var view=new View({
          center: [-12384991, 2970341],
          zoom: 7
        });
      var map = new Map({
        layers: [rasterLayer, vectorLayer,vector],
        target: document.getElementById('map'),
        view: view
      });

      var element = document.getElementById('popup');

      var popup = new Overlay({
        element: element,
        positioning: 'bottom-center',
        stopEvent: false,
        offset: [0, -50]
      });
      map.addOverlay(popup);

      // display popup on click
      map.on('click', function(evt) {
        var feature = map.forEachFeatureAtPixel(evt.pixel,
          function(feature) {
            return feature;
          });
        if (feature) {
          var coordinates = feature.getGeometry().getCoordinates();
          popup.setPosition(coordinates);
          $(element).popover({
            placement: 'top',
            html: true,
            content: feature.get('name')
          });
          $(element).popover('show');
        } else {
          $(element).popover('destroy');
        }
      });

      // change mouse cursor when over marker
      map.on('pointermove', function(e) {
        if (e.dragging) {
          $(element).popover('destroy');
          return;
        }
        var pixel = map.getEventPixel(e.originalEvent);
        var hit = map.hasFeatureAtPixel(pixel);
        map.getTarget().style.cursor = hit ? 'pointer' : '';
      });
	  var modify = new Modify({source: source});
      map.addInteraction(modify);

      var draw, snap; // global so we can remove them later 
	  
	  var myInteractions_on= document.getElementById("interactions_on");
	   var feature_type= document.getElementById("type");
	  myInteractions_on.onclick =function(){     
        draw = new Draw({
          source: source,
          type: feature_type.value
        });
        map.addInteraction(draw);
        snap = new Snap({source: source});
        map.addInteraction(snap);

      }
	  var myInteractions_off= document.getElementById("interactions_off");
	  myInteractions_off.onclick =function() {
        map.removeInteraction(draw);
        map.removeInteraction(snap);
        addInteractions();
      };
      function addInteraction() {
        var value = typeSelect.value;
        if (value !== 'None') {
          draw = new Draw({
            source: source,
            type: typeSelect.value
          });
          map.addInteraction(draw);
        }
      }
	  var myInstance= document.getElementById("instance");
	  myInstance.onclick =function(){		  
			var wkt = 'POLYGON((-12600000 3150000, -12300000 ' +
					  '3150000, -12300000 2800000, -12600000 ' +
					  '2800000, -12600000 3150000))';
			var wkt2= document.getElementById("openlayers_wkt").value;
			var format = new WKT();
			var feature = format.readFeature(wkt2, {
				dataProjection: 'EPSG:900913',
				featureProjection: 'EPSG:900913'
			 });
			 var vector3 = new VectorLayer({
				source: new VectorSource({
				  features: [feature]
				}),
				style: new Style({
				  fill: new Fill({
					color: 'rgba(255, 255, 255, 0.2)'
				  }),
				  stroke: new Stroke({
					color: '#0000ff',
					lineDash:[8,16],
					width: 4
				  }),
				  image: new CircleStyle({
					radius: 7,
					fill: new Fill({
					  color: '#ffcc33'
					})
				  })
				})
			});
		   var mm =map;
		   mm.addLayer(vector3);
		   
		   view.fit(vector3.getSource().getExtent(), {duration: 1000});
	  }
	  var myInstance= document.getElementById("drawicon");
	  myInstance.onclick =function(){		  			
			var wktx= document.getElementById("openlayers_iconx").value;
			var wkty= document.getElementById("openlayers_icony").value;			
			var iconFeature = new Feature({
				geometry: new Point([wktx, wkty]),
				name: 'SRS-punto',
				population: 4000,
				rainfall: 500
			  });

			  var iconStyle = new Style({
				image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
				  anchor: [0.5, 46],
				  anchorXUnits: 'fraction',
				  anchorYUnits: 'pixels',
				  src: 'data/identify_active.png',
				  //rotation: -Math.PI / 2.0
				}))
			  });

			  iconFeature.setStyle(iconStyle);

			  var vectorSource = new VectorSource({
				features: [iconFeature]
			  });

			  var vectorLayer = new VectorLayer({
				source: vectorSource
			  });
		   var mm =map;
		   mm.addLayer(vectorLayer);
		   
		   //view.fit(vectorLayer.getSource().getExtent(), {duration: 1000});
	  }
